import SearchBar from "components/SearchBar";
import React, { useEffect, useState } from "react";
import { useToasts } from "helper/ToastAdapter";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Col,
  Row,
  Table,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { postApi } from "redux/action/api_tbeams";
import CustomTypeahead from "components/CustomTypeahead";
import { getSector } from "helper";

function CustomInput() {
  const [formData, setFormData] = useState({
    mda_name: "",
    mda_code: "",
    mda_name_abbreviationName: "",
    office_title: "",
    office_title_abbreviation: "",
    prefix: "",
    id: 0,
  });

  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [del, setDel] = useState(false);
  const [mdaOptions, setMdaOptions] = useState([]);
  const [selectedMda, setSelectedMda] = useState([]);

  const toggle = () => setOpen(!open);
  const toggleDel = () => setDel(!del);

  const { addToast } = useToasts();

  // Fetch MDA list on component mount
  useEffect(() => {
    getSector({ type: "mdas" }, "mdas", (data) => {
      const formattedData = data?.map((item) => ({
        head: `${item.head}-${item.description}`,
        description: item.description,
        code: item.head,
      }));
      setMdaOptions(formattedData || []);
    });
  }, []);

  // Auto-generate abbreviation from text (first letter of each word)
  const generateAbbreviation = (text) => {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    const abbreviation = words
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
    return abbreviation;
  };

  // Auto-generate prefix (first 3-4 letters of first word)
  const generatePrefix = (text) => {
    if (!text) return "";
    const firstWord = text.trim().split(/\s+/)[0];
    const prefixLength = firstWord.length >= 4 ? 4 : 3;
    const prefix = firstWord.substring(0, prefixLength).toUpperCase();
    return prefix;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFormData = { ...formData, [name]: value };

    // Auto-generate abbreviation and prefix when MDA name changes
    if (name === "mda_name") {
      newFormData.mda_name_abbreviationName = generateAbbreviation(value);
      newFormData.prefix = generatePrefix(value);
    }

    // Auto-generate office title abbreviation
    if (name === "office_title") {
      newFormData.office_title_abbreviation = generateAbbreviation(value);
    }

    setFormData(newFormData);
  };
  let type =
    formData.type === "update"
      ? "update"
      : formData.type === "delete"
        ? "delete"
        : "create";
  const getCCCopies = () => {
    setLoading(true);
    postApi(`post-cc?query_type=select`)
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          // const arr = data.result.map((item) => ({
          //   ...item,
          // }));
          setTableData(data.results);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        addToast("Fail to Fetch", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    // Validate required fields
    if (!formData.mda_name || !formData.mda_name.trim()) {
      addToast("MDA Name is required", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    if (!formData.mda_code || !formData.mda_code.trim()) {
      addToast("MDA Code is required", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    if (!formData.office_title || !formData.office_title.trim()) {
      addToast("Office Title is required", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    if (
      !formData.mda_name_abbreviationName ||
      !formData.mda_name_abbreviationName.trim()
    ) {
      addToast("MDA Abbreviation is required", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    if (
      !formData.office_title_abbreviation ||
      !formData.office_title_abbreviation.trim()
    ) {
      addToast("Office Title Abbreviation is required", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    if (!formData.prefix || !formData.prefix.trim()) {
      addToast("Prefix is required and cannot be empty", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    // Check for duplicates only when creating a new record
    if (type === "create") {
      // Check if MDA Name already exists
      const mdaExists = tableData.some(
        (item) =>
          item.mdaName?.toLowerCase().trim() ===
          formData.mda_name?.toLowerCase().trim(),
      );

      if (mdaExists) {
        addToast("MDA Name already exists. Please select a different MDA.", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
        return;
      }

      // Check if Prefix already exists
      const prefixExists = tableData.some(
        (item) =>
          item.prefix?.toLowerCase().trim() ===
          formData.prefix?.toLowerCase().trim(),
      );

      if (prefixExists) {
        addToast("Prefix already exists. Please use a different prefix.", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
        return;
      }
    }

    // Check for duplicates when updating (exclude current record)
    if (type === "update") {
      // Check if MDA Name already exists (excluding current record)
      const mdaExists = tableData.some(
        (item) =>
          item.id !== formData.id &&
          item.mdaName?.toLowerCase().trim() ===
            formData.mda_name?.toLowerCase().trim(),
      );

      if (mdaExists) {
        addToast("MDA Name already exists. Please select a different MDA.", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
        return;
      }

      // Check if Prefix already exists (excluding current record)
      const prefixExists = tableData.some(
        (item) =>
          item.id !== formData.id &&
          item.prefix?.toLowerCase().trim() ===
            formData.prefix?.toLowerCase().trim(),
      );

      if (prefixExists) {
        addToast("Prefix already exists. Please use a different prefix.", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
        return;
      }
    }

    setIsLoading(true);
    postApi(`post-cc?query_type=${type}&id=${formData.id}`, formData)
      .then((data) => {
        if (data.success) {
          toggle();
          addToast("Form submitted successfully!", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          setIsLoading(false);
          setFormData({
            office_title: "",
            mda_name: "",
            mda_code: "",
            mda_name_abbreviationName: "",
            office_title_abbreviation: "",
            prefix: "",
          });
          getCCCopies();
        }
      })
      .catch((err) => {
        console.log(err);
        addToast("An error occurred", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
        setIsLoading(false);
      });
  };

  // Function to open modal for creating new CC copy
  const handleAddNew = () => {
    setFormData({
      type: "create",
      mda_name: "",
      mda_code: "",
      mda_name_abbreviationName: "",
      office_title: "",
      office_title_abbreviation: "",
      prefix: "",
      id: 0,
    });
    setSelectedMda([]);
    toggle();
  };

  useEffect(() => {
    getCCCopies();
  }, []);

  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    console.log("searchText", searchText);
  };

  const rows = [];
  tableData?.forEach((item) => {
    if (
      item.mdaName &&
      item.mdaName?.toLowerCase().indexOf(searchText?.toLowerCase()) === -1
    )
      return;
    else rows.push(item);
  });
  return (
    <div>
      <Modal isOpen={del} toggle={toggleDel} size="md" color="danger">
        <ModalBody>
          <div className="text-danger">Are you sure you want to delete</div>
          <b>{formData.mda_name}</b>
        </ModalBody>
        <center className="m-2">
          <Button
            color="success"
            variant="success"
            onClick={toggleDel}
            className="mx-2"
          >
            Cancel
          </Button>
          <Button color="danger" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? <Spinner color="light" size="sm" /> : "Confirm"}
          </Button>
        </center>
      </Modal>

      <Modal isOpen={open} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <center>
            {formData.type === "update" ? "Update CC Copy" : "Add New CC Copy"}
          </center>
        </ModalHeader>
        <ModalBody>
          <Form className="m-1">
            <Row form>
              <Col md={12}>
                <FormGroup>
                  {formData.type === "update" ? (
                    <>
                      <Label for="mdaCode">
                        MDA Code <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        id="mdaCode"
                        type="text"
                        placeholder="Enter MDA Code"
                        value={formData.mda_code}
                        name="mda_code"
                        onChange={handleChange}
                        required
                      />
                      <Label for="mdaName" className="mt-3">
                        MDA Name <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        id="mdaName"
                        type="text"
                        placeholder="Enter MDA Name"
                        value={formData.mda_name}
                        name="mda_name"
                        onChange={handleChange}
                        required
                      />
                    </>
                  ) : (
                    <CustomTypeahead
                      labelKey="head"
                      label={
                        <>
                          Select MDA <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      placeholder="Select MDA (e.g., Ministry of Education)"
                      options={mdaOptions}
                      selected={selectedMda}
                      onChange={(selected) => {
                        if (selected.length > 0) {
                          const mdaName = selected[0].description;
                          const code = selected[0].code;
                          setSelectedMda(selected);
                          setFormData({
                            ...formData,
                            mda_name: mdaName,
                            mda_code: code,
                            mda_name_abbreviationName:
                              generateAbbreviation(mdaName),
                            prefix: generatePrefix(mdaName),
                          });
                        } else {
                          setSelectedMda([]);
                          setFormData({
                            ...formData,
                            mda_name: "",
                            mda_code: "",
                            mda_name_abbreviationName: "",
                            prefix: "",
                          });
                        }
                      }}
                    />
                  )}
                  <small
                    style={{
                      color: "#6c757d",
                      marginTop: "5px",
                      display: "block",
                    }}
                  >
                    Abbreviation and Prefix will be auto-generated
                  </small>
                </FormGroup>
              </Col>
            </Row>

            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="mdaNameAbbreviation">
                    MDA Abbreviation
                    <span style={{ color: "red", marginRight: "5px" }}>*</span>
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#28a745",
                        fontWeight: 500,
                      }}
                    >
                      (Auto)
                    </span>
                  </Label>
                  <Input
                    id="mdaNameAbbreviation"
                    type="text"
                    placeholder="MOE"
                    value={formData.mda_name_abbreviationName}
                    name="mda_name_abbreviationName"
                    onChange={handleChange}
                    required
                    style={{
                      border: "2px solid #28a745",
                      backgroundColor: "#f0f9f4",
                    }}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="prefix">
                    Prefix
                    <span style={{ color: "red", marginRight: "5px" }}>*</span>
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#28a745",
                        fontWeight: 500,
                      }}
                    >
                      (Auto)
                    </span>
                  </Label>
                  <Input
                    id="prefix"
                    type="text"
                    placeholder="MINI"
                    value={formData.prefix}
                    name="prefix"
                    onChange={handleChange}
                    required
                    style={{
                      border: "2px solid #28a745",
                      backgroundColor: "#f0f9f4",
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="officeTitle">
                    Office Title <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    id="officeTitle"
                    type="text"
                    placeholder="Enter Office Title (e.g., Director General)"
                    value={formData.office_title}
                    name="office_title"
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="officeTitleAbbreviation">
                    Office Title Abbreviation
                    <span style={{ color: "red", marginRight: "5px" }}>*</span>
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#28a745",
                        fontWeight: 500,
                      }}
                    >
                      (Auto)
                    </span>
                  </Label>
                  <Input
                    id="officeTitleAbbreviation"
                    type="text"
                    placeholder="DG"
                    value={formData.office_title_abbreviation}
                    name="office_title_abbreviation"
                    onChange={handleChange}
                    required
                    style={{
                      border: "2px solid #28a745",
                      backgroundColor: "#f0f9f4",
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button
            color="warning"
            variant="warning"
            className="btn btn-warning"
            onClick={toggle}
          >
            Cancel
          </Button>
          <Button color="success" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? <Spinner color="light" size="sm" /> : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <SearchBar
          placeholder="Search By MDA Name"
          filterText={searchText}
          onChange={handleSearchChange}
        />
        <Button
          color="success"
          onClick={handleAddNew}
          style={{
            marginLeft: "15px",
            fontWeight: 600,
            padding: "8px 20px",
            boxShadow: "0 4px 6px rgba(76, 175, 80, 0.3)",
          }}
        >
          <i className="fas fa-plus-circle" style={{ marginRight: "8px" }}></i>
          Add New
        </Button>
      </div>
      <Table bordered className="mt-3">
        <thead>
          <tr>
            <td
              style={{
                fontSize: 15,
              }}
            >
              S/N
            </td>

            <td
              style={{
                fontSize: 15,
              }}
            >
              MDA Name
            </td>
            <td
              style={{
                fontSize: 15,
              }}
            >
              MDA NAME ABBREVIATION
            </td>
            <td
              style={{
                fontSize: 15,
              }}
            >
              Office Title
            </td>
            <td
              style={{
                fontSize: 15,
              }}
            >
              Office Title ABBREVIATION
            </td>
            <td
              style={{
                fontSize: 15,
              }}
            >
              Prefix
            </td>
            <td
              style={{
                fontSize: 15,
              }}
            >
              Action
            </td>
          </tr>
        </thead>
        {loading ? (
          <Spinner color="primary" />
        ) : (
          <tbody>
            {rows?.map((data) => (
              <tr key={data.id}>
                <td
                  style={{
                    fontSize: 15,
                  }}
                  scope="row"
                >
                  {data.id}
                </td>
                <td
                  style={{
                    fontSize: 15,
                  }}
                >
                  {data.mdaName}
                </td>
                <td
                  style={{
                    fontSize: 15,
                  }}
                >
                  {data.mdaNameAbbreviation}
                </td>
                <td
                  style={{
                    fontSize: 15,
                  }}
                >
                  {data.officeTitle}
                </td>
                <td
                  style={{
                    fontSize: 15,
                  }}
                >
                  {data.offivetitleAbbreviation}
                </td>
                <td
                  style={{
                    fontSize: 15,
                  }}
                >
                  {data.prefix}
                </td>
                <td
                  style={{
                    fontSize: 15,
                  }}
                  className="d-flex justify-content-around"
                >
                  <Button
                    size="sm"
                    color="success"
                    className="m-2"
                    style={{
                      fontSize: 15,
                    }}
                    onClick={() => {
                      // Find the corresponding MDA from mdaOptions for the typeahead
                      const matchedMda = mdaOptions.find(
                        (mda) => mda.description === data.mdaName,
                      );

                      setFormData({
                        type: "update",
                        id: data.id,
                        office_title: data.officeTitle,
                        mda_name: data.mdaName,
                        mda_code: data.mdaCode || data.mda_code || "",
                        mda_name_abbreviationName: data.mdaNameAbbreviation,
                        office_title_abbreviation: data.offivetitleAbbreviation,
                        prefix: data.prefix || "",
                        ...data,
                      });

                      // Set the selectedMda for typeahead
                      setSelectedMda(matchedMda ? [matchedMda] : []);
                      toggle();
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    color="danger"
                    className="m-2"
                    style={{
                      fontSize: 15,
                    }}
                    onClick={() => {
                      setFormData({
                        type: "delete",
                        id: parseInt(data.id),
                        mda_name: data.mdaName,
                        mda_code: data.mdaCode || data.mda_code || "",
                      });
                      toggleDel();
                    }}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </Table>
    </div>
  );
}

export default CustomInput;
